if (!customElements.get('fsk-collection-results')) {
  customElements.define('fsk-collection-results', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.contentURL = location.pathname + location.search;
      const options = { signal: this.controller.signal };
      this.preserveLinks();
      this.addEventListener('submit', event => {
        const form = event.target.closest('[data-filter-form]');
        if (!form) return;
        event.preventDefault();
        const url = new URL(form.action, location.origin);
        const params = new URLSearchParams(new FormData(form));
        for (const [key, value] of [...params]) if (value === '') params.delete(key);
        url.search = params.toString();
        this.navigate(this.previewURL(url), true);
      }, options);
      this.addEventListener('change', event => {
        if (event.target.matches('[data-sort]')) event.target.form.requestSubmit();
      }, options);
      this.addEventListener('click', event => {
        const link = event.target.closest('a[data-results-link]');
        if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.altKey || event.shiftKey) return;
        event.preventDefault();
        this.navigate(this.previewURL(new URL(link.href)), true);
      }, options);
      window.addEventListener('popstate', () => {
        if (location.pathname + location.search !== this.contentURL) this.navigate(this.previewURL(new URL(location.href)), false);
      }, options);
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.request?.abort();
      this.controller = null;
    }
    previewURL(url) {
      if (this.dataset.view) url.searchParams.set('view', this.dataset.view);
      else url.searchParams.delete('view');
      if (this.dataset.theme) {
        url.searchParams.set('preview_theme_id', this.dataset.theme);
        for (const [key, value] of new URL(location.href).searchParams) {
          if (key.startsWith('preview_') || key === '_fd' || key === 'pb') {
            if (!url.searchParams.has(key)) url.searchParams.set(key, value);
          }
        }
      } else {
        for (const key of [...url.searchParams.keys()]) {
          if (key.startsWith('preview_') || key === '_fd' || key === 'pb') url.searchParams.delete(key);
        }
      }
      return url;
    }
    preserveLinks() {
      this.querySelectorAll('a[data-results-link]').forEach(link => {
        link.href = this.previewURL(new URL(link.href)).href;
      });
    }
    async navigate(url, addHistory) {
      this.request?.abort();
      const request = new AbortController();
      this.request = request;
      this.setAttribute('aria-busy', 'true');
      try {
        const response = await fetch(url.href, { signal: request.signal, credentials: 'same-origin' });
        if (!response.ok) throw new Error('Unable to load collection');
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const replacement = html.querySelector('fsk-collection-results');
        if (!replacement || replacement.dataset.view !== this.dataset.view) throw new Error('Preview unavailable');
        if (request.signal.aborted) return;
        this.innerHTML = replacement.innerHTML;
        this.preserveLinks();
        if (addHistory) history.pushState({}, '', url.href);
        this.contentURL = location.pathname + location.search;
        const title = this.querySelector('[data-results-title]');
        title?.focus({ preventScroll: true });
        this.scrollIntoView({ behavior: 'instant', block: 'start' });
        if (!matchMedia('(prefers-reduced-motion: reduce)').matches) {
          this.querySelector('[data-product-area]')?.animate([{ opacity: .5, transform: 'translateY(5px)' }, { opacity: 1, transform: 'translateY(0)' }], { duration: 220, easing: 'ease-out' });
        }
      } catch (error) {
        if (error.name !== 'AbortError') location.assign(url.href);
      } finally {
        if (this.request === request) this.removeAttribute('aria-busy');
      }
    }
  });
}
